/** @format */

import {subtractArrays} from 'helpers/arrayHelpers';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';

type Options = {
  oldSelections: ChartIds[]; // старый вариант чартов, выбранных в подменю
  newSelections: ChartIds[]; // новый вариант чартов, выбранных в подменю
  currentList: ChartIds[]; // текущий выбор чекбоксов в главном меню
};

const getNewBoardWidgets = ({oldSelections, newSelections, currentList}: Options): ChartIds[] => {
  const removedSelections = subtractArrays(oldSelections, newSelections);

  const addedSelections = subtractArrays(newSelections, oldSelections);

  const currentWithoutRemoved = currentList.filter(id => !removedSelections.includes(id));

  return [...addedSelections, ...currentWithoutRemoved];
};

export {getNewBoardWidgets};
